module.exports = __webpack_public_path__ + "img/sale-order-v2.33b35859.jpg";